import {FooterMenu, Section} from '~/components';
import { Link } from '@shopify/hydrogen';
// import { useUrl } from '@shopify/hydrogen';

import type {EnhancedMenu} from '~/lib/utils';

/**
 * A server component that specifies the content of the footer on the website
 */
export function Footer({menu, onClose}: {menu?: EnhancedMenu; onClose?: () => void}) {
  // const {pathname} = useUrl();

  // const localeMatch = /^\/([a-z]{2})(\/|$)/i.exec(pathname);
  // const countryCode = localeMatch ? localeMatch[1] : null;

  // const isHome = pathname === `/${countryCode ? countryCode + '/' : ''}`;

  return (
    <Section as="footer" role="contentinfo">
      <nav className='flex flex-col'>
        {menu?.items?.map((subItem) => (
          <Link onClick={onClose} key={subItem.id} to={subItem.to} target={subItem.target}>
            {subItem.title}
          </Link>
        ))}
        <br />
        <a
          href="https://www.instagram.com/gauntlettcheng/"
          target="_blank"
          rel="noreferrer"
        >
          Instagram
        </a>
      </nav>
      {/* <FooterMenu menu={menu} /> */}
    </Section>
  );
}
